import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { createQueryKey } from '@hero/utils';

import { contactServices } from '../..';

function useGetContact(params = {}, options) {
  return useQuery(
    createQueryKey(QUERY_KEYS.useGetContactKey, params),
    () => contactServices.getContact(params.id),
    options
  );
}

export { useGetContact };
